export class Onderwerp {
    constructor(
      public Start?: Date,
      public Tot?: Date,
      public OnderwerpID: number = 0, 
      public FunctieID: number = 0, 
      public AantalItems: number = 0, 
      public IngeplandeMedewerkers: number = 0, 
      public BedrijfID: number = 0, 
      public Storing: number = 0, 
      public InternMonteurInfo: string = "",
      public Bedrijf: string= "",
      public Notitie: string= "",
      public Afk: string= "",
      public Onderwerp: string= "",
      public Patroon: number = 0, 
      public Dagen: number = 0, 
      public Weken: number = 0, 
      public Maanden: number = 0, 
      public AuteurID: number = 0, 
      public Auteur:string = "", 
      public GewijzigdOp?: any,
      public UrenCatID: number = 0
    ){}
  }


